import React, { useEffect, useState } from "react";
import "./App.css";
import i18n from "i18next";
import { initReactI18next, Trans, withTranslation } from "react-i18next";
import { PrivacyNotificationDialog, SubmitDialog } from "./components/dialog";
import { useDispatch, useSelector } from "react-redux";
import { elementAction, feedbackAction, uwpAction } from "./store";
import Backend from "i18next-http-backend";
import Uwp, { UploadFileStatusEnum } from "./utils/uwp";
import Log from "./utils/log";
import { AppClient } from "./utils/tool/client";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./Home";
import LikeConfirm from "./LikeConfirm";
import { compareVersion } from "./utils/format";
import DebugPanel from "./components/DebugPanel";
let lng = "en";

// i18n
//   .use(Backend)
//   // .use(LanguageDetector) //偵測瀏覽器語言
//   .use(initReactI18next) // passes i18n down to react-i18next
//   .init({
//     // the translations
//     // (tip move them in a JSON file and import them,
//     // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
//     backend: {
//       loadPath: process.env.PUBLIC_URL + "/locales/{{lng}}/{{ns}}.json",
//     },
//     lng, // disabled detection
//     fallbackLng: {
//       default: ["en"],
//       "zh-hant": ["zh-TW"],
//       "zh-hans": ["zh-CN"],
//     },
//     react: {
//       transSupportBasicHtmlNodes: true,
//       transKeepBasicHtmlNodesFor: ["br", "strong", "b", "i"],
//       wait: true,
//     },
//     interpolation: {
//       escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
//     },
//   })
//   .then((r) => {});

i18n
  .use(Backend)
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      // 覆寫 loadPath：md: 開頭抓 .md；其他一律抓 translation.json
      loadPath: (lngs, namespaces) => {
        const ns = Array.isArray(namespaces) ? namespaces[0] : namespaces;
        const lang = lngs[0];

        // 針對 "md:privacy" 的特殊處理
        if (ns === "md:privacy") {
          const markdownName = ns.slice(3); // 取得 "privacy"
          return `${
            process.env.PUBLIC_URL || ""
          }/locales/${markdownName}/${lang}.md`;
        }

        // 原本的邏輯
        const isMd = typeof ns === "string" && ns.startsWith("md:");
        const file = isMd
          ? `${ns.slice(3)}.md` // 例如 md:terms -> terms.md
          : "translation.json"; // 一般翻譯固定用 translation.json
        return `${process.env.PUBLIC_URL || ""}/locales/${lang}/${file}`;
      },
      // 讓 .md 直接當純文字載入；.json 照常解析
      parse: (data, _lng, ns) => {
        const _ns = Array.isArray(ns) ? ns[0] : ns;
        const isMd = typeof _ns === "string" && _ns.startsWith("md:");
        if (isMd) return { __markdown__: data }; // 整份 md 放固定 key
        try {
          return JSON.parse(data);
        } catch {
          return {};
        }
      },
    },

    // 你原本的設定保留
    lng,
    fallbackLng: {
      default: ["en"],
      "zh-hant": ["zh-TW"],
      "zh-hans": ["zh-CN"],
    },
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["br", "strong", "b", "i"],
      wait: true,
    },
    interpolation: { escapeValue: false },

    // 告訴 i18next 我們會用到哪些 namespace
    ns: ["translation", "md:privacy"], // 可再加 md:privacy、md:faq…
    defaultNS: "translation",
  });

function App({ t, i18n }) {
  const dispatch = useDispatch();
  const [selectedLikeType, setSelectedLikeType] = useState("");
  const privacyNotificationDialogId = useSelector(
    (state) => state.element.privacyNotificationDialogId
  );

  const submitDialogId = useSelector((state) => state.element.submitDialogId);
  const errorDialogId = useSelector((state) => state.element.errorDialogId);
  const lang = useSelector((state) => state.element.lang);
  const isShowErrorDialog = useSelector(
    (state) => state.element.isShowErrorDialog
  );
  const isShowPrivacyNotificationDialog = useSelector(
    (state) => state.element.isShowPrivacyNotificationDialog
  );
  const reportCodeDialogId = useSelector(
    (state) => state.element.reportCodeDialogId
  );
  const isShowReportCodeDialog = useSelector(
    (state) => state.element.isShowReportCodeDialog
  );
  const isShowSubmitDialog = useSelector(
    (state) => state.element.isShowSubmitDialog
  );
  const attachmentFileUploadDone = useSelector(
    (state) => state.feedback.attachmentFileUploadDone
  );
  const uploadStatus = useSelector((state) => state.uwp.uploadStatus);
  const uploadProgress = useSelector((state) => state.uwp.uploadProgress);
  const [isSetLanguage, setIsSetLanguage] = React.useState(false);
  const focusNameList = useSelector((state) => state.element.focusNameList);
  const theme = useSelector((state) => state.element.theme);
  const [loadingImgType, setLoadingImgType] = useState("dark");

  const getTheme = async () => {
    if (Uwp.getBridge()) {
      Log.debug("[UWP] start get theme ");
      const themeType = await Uwp.getThemeType();
      if (themeType) {
        const t = themeType.toLowerCase();
        Log.debug("[UWP] start get theme ", t);
        switch (t) {
          case "light":
            dispatch(elementAction.setTheme("light"));
            break;
          default:
            dispatch(elementAction.setTheme("rog"));
        }
      }
    } else {
      setLoadingImgType("light");
      dispatch(elementAction.setTheme("light"));
      Log.debug("[UWP] no UWP, skip get theme ");
    }
  };

  const getCurrentLanguage = async () => {
    let lang = navigator.language || navigator.userLanguage;
    if (Uwp.getBridge()) {
      lang = await Uwp.getCurrentLanguage();
      Log.info("use UWP language:", lang);
      // TODO: 刪除此測試
      // lang = "en";
    } else {
      Log.info("use browser language:", lang);
    }
    if (!lang.includes("zh")) {
      lang = lang.split("-")[0].toLowerCase();
    }
    console.log("lang", lang);
    document.documentElement.lang = lang;
    dispatch(elementAction.setLang(lang));

    setTimeout(() => {
      setIsSetLanguage(true);
      dispatch(elementAction.setLang(lang));
    }, 1000);
  };
  const getCountryCode = async () => {
    const countryCode = await AppClient.getCountry();
    if (!countryCode) {
      Log.error("[UWP] get country code fail, use default TW");
      dispatch(feedbackAction.setGeoCountry("TW"));
      return;
    }
    dispatch(feedbackAction.setGeoCountry(countryCode));
  };

  const getUserInfo = async () => {
    if (Uwp.getBridge()) {
      Log.debug("[UWP] start get user info ");
      const userInfo = await Uwp.getLoginUserInfo();
      if (userInfo) {
        Log.debug("[UWP] start get user info ", userInfo);
        dispatch(feedbackAction.setEmail(userInfo.Email));
      }
    } else {
      Log.debug("[UWP] no UWP, skip get user info ");
    }
  };

  async function getVersion() {
    const runtimeConfig = window.config;

    if (Uwp.getBridge()) {
      try {
        const isSupportRemotePlay = await Uwp.isSupportRemotePlay();
        Log.debug("[UWP] is support remote play ", isSupportRemotePlay);
        dispatch(uwpAction.setEnableRemoteCode(isSupportRemotePlay));
      } catch (e) {
        Log.error("[UWP] get version error", e);
        dispatch(uwpAction.setEnableRemoteCode(false));
      }
      try {
        const appVersion = await Uwp.getUwpAppVersion();
        dispatch(uwpAction.setAppVersion(appVersion));
      } catch (e) {
        Log.error("[UWP] get app version error", e);
      }
    } else {
      const version = "6.3.1.0";

      dispatch(uwpAction.setAppVersion(version));
      const compare = compareVersion(version, runtimeConfig.REMOTE_CODE_VERSION);
      Log.debug(
        "[UWP] no UWP, use fake version ",
        version,
        runtimeConfig.REMOTE_CODE_VERSION,
        compare
      );
      dispatch(uwpAction.setEnableRemoteCode(compare));
    }
  }

  useEffect(() => {
    getVersion();
    getTheme();
    getUserInfo();
    getCurrentLanguage();
    getCountryCode();
  }, []);

  useEffect(() => {
    Log.debug("[UWP] change upload status ", uploadStatus);
    if (uploadStatus === UploadFileStatusEnum.UploadFileFinish) {
      dispatch(feedbackAction.submitSuccess());
    }
    if (uploadStatus > UploadFileStatusEnum.PackageEnd) {
      if (uploadStatus % 100 === 0 || uploadStatus % 100 === 2) {
        dispatch(
          feedbackAction.setLogUploadProgress(80 + Number(uploadProgress) * 0.2)
        );
      }
      if (Number(uploadStatus) % 100 === 4) {
        Log.error("[UWP] upload fail, dispatch submitFailed", uploadStatus);
        dispatch(feedbackAction.submitFailed());
      }
    }
  }, [uploadStatus]);

  useEffect(() => {
    if (selectedLikeType === "") {
      Uwp.clearWebContent();
    } else {
      Uwp.changeWebContent();
    }
  }, [selectedLikeType]);

  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang]);

  useEffect(() => {
    if (attachmentFileUploadDone) {
      dispatch(feedbackAction.submitSuccess());
    }
  }, [attachmentFileUploadDone]);
  return (
    <>
      <Router>
        <Routes>
          <Route
            path="/ac-feedback-hub"
            element={<Home t={t} i18n={i18n} isSetLanguage={isSetLanguage} />}
          />
          <Route
            path="/ac-feedback-hub/like-confirm"
            element={<LikeConfirm t={t} i18n={i18n} />}
          />
        </Routes>
      </Router>
      {process.env.NODE_ENV === 'development' && <DebugPanel />}
    </>
  );
}

export default withTranslation()(App);
